import {
  useModalContext,
  useWSSnackbar,
  WSButton,
  WSButtons,
  WSForm,
  WSModal,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { WSErrorMessage } from "../../components/WSErrorMessage/WSErrorMessage";
import { ErrorContextKey } from "../../services/platform";
import { useTemrinateCard } from "../../query/payments/mutations";
import { useHistory } from "react-router-dom";

export const REPLACE_OR_TERMINATE_CARD_MODAL =
  "REPLACE_OR_TERMINATE_CARD_MODAL";

const Inner: React.FC<{ cardId: string }> = props => {
  const { closeModal, openModal } = useModalContext();
  const history = useHistory();
  const { openSnackbar } = useWSSnackbar();

  const [terminateCard, terminateCardMeta] = useTemrinateCard();

  return (
    <>
      <WSText.Heading3 mb="M">Order a new card?</WSText.Heading3>
      <WSText.Paragraph>
        Your old card will be terminated and we will send you a replacement card
        with new numbers. You will just have to activate it and set the PIN.
      </WSText.Paragraph>

      <WSForm
        onSubmit={async () => {
          await terminateCard(props.cardId, {
            onSuccess() {
              closeModal(REPLACE_OR_TERMINATE_CARD_MODAL);
              history.push("/member/wallet/dashboard");
              openSnackbar({ message: "Card terminated." });
            }
          });
        }}
      >
        <WSErrorMessage
          mt="M"
          error={terminateCardMeta.error}
          contextKey={ErrorContextKey.Other}
        />

        <WSButtons mt="M" format="modal">
          <WSForm.SubmitButton kind="Destructive" fullWidth>
            Just terminate
          </WSForm.SubmitButton>
          <WSButton.Secondary
            onClick={() => {
              openModal("");
            }}
          >
            Replace
          </WSButton.Secondary>
        </WSButtons>
      </WSForm>
    </>
  );
};

export const ReplaceOrTerminateCard: React.FC<{ cardId: string }> = props => {
  const { closeModal } = useModalContext();

  return (
    <WSModal
      name={REPLACE_OR_TERMINATE_CARD_MODAL}
      size="S"
      onClose={() => closeModal(REPLACE_OR_TERMINATE_CARD_MODAL)}
    >
      <Inner cardId={props.cardId} />
    </WSModal>
  );
};
